<template>
  <div>
    <CardedTable :items="items" :headers="headers">
      <template v-slot:[`item.city`]="{ item }">
        <v-icon>{{ item.city.name }}</v-icon>
      </template>
      <template v-slot:[`item.district`]="{ item }">
        <v-icon>{{ item.district.name }}</v-icon>
      </template>

      <template v-slot:[`item.country`]="{ item }">
        <v-icon>{{ item.country.name }}</v-icon>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="on_view_item(item)" x-small rounded text color="success">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </CardedTable>
  </div>
</template>

<script>
import CardedTable from "../../../components/CardedTable";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminWardsList",
  components: {
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: false,
    },
  },
  data: () => {
    return {
      items: [],
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
          filterable: true,
        },
        {
          text: "City",
          align: "start",
          sortable: true,
          value: "city.name",
          filterable: true,
        },
        {
          text: "District",
          align: "start",
          sortable: true,
          value: "district.name",
          filterable: true,
        },
        {
          text: "Country",
          align: "start",
          sortable: false,
          value: "country.name",
          filterable: false,
        },
        { text: "", value: "actions", sortable: false },
      ],
    };
  },
  methods: {
    load_items() {
      this.$emit("on-show-loader");
      ServerClient.Locations.get_wards(
        {
          is_admin: true,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.items = res;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log("Errors while loading wards on admin list", errors);
        }
      );
    },
    on_view_item(item) {
      this.$router.push("/admin/locations/wards/view/" + item.id);
    },
  },
  mounted() {
    this.$emit("set-page-attributes", {
      title: "Wards List",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Locations",
          disabled: false,
          href: "/admin/locations",
        },
        {
          text: "Wards",
          disabled: true,
          href: "/admin/locations/wards/list",
        },
      ],
    });
    this.load_items();
  },
};
</script>